import type { Notification, NotificationData } from '@repo/models';

const POS_ORDER_SYNC_FAILED = 'POS_ORDER_SYNC_FAILED';

export type PosOrderSyncFailureLog = {
  notificationId: string;
  orderId: string | null;
  tableName: string | null;
};

export function posOrderSyncFailureLog(notification: Notification): PosOrderSyncFailureLog | null {
  if (notification.type !== POS_ORDER_SYNC_FAILED) {
    return null;
  }

  return {
    notificationId: notification.id,
    orderId: readOrderId(notification.data),
    tableName: notification.table?.name ?? null,
  };
}

function readOrderId(data: Notification['data']): string | null {
  const record = parseNotificationData(data);
  const orderId = record?.orderId;
  return typeof orderId === 'string' && orderId.length > 0 ? orderId : null;
}

function parseNotificationData(data: Notification['data']): NotificationData | null {
  if (data == null) {
    return null;
  }

  if (typeof data === 'string') {
    try {
      const parsed: unknown = JSON.parse(data);
      if (parsed != null && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return parsed as NotificationData;
      }
    } catch {
      return null;
    }
    return null;
  }

  return data;
}
